import { Injectable } from '@angular/core'
import { FormControl } from '@angular/forms'

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  convertEmailsToList(emailsFormControl: FormControl<string | null> | null): string[] {
    const emailsValue = emailsFormControl?.value

    if (!emailsValue) {
      return []
    }

    return emailsValue
      .split(/\s*;\s*/)
      .map((email) => email.trim())
      .filter((email) => email.length > 0)
  }
}
